import React from "react";
import { ArrowRight, Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
export default function TheArtOfFirstImpressions() {
  return <section data-section-id="238598" id="the-art-of-first-impressions" className="bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute -right-[10%] -top-[10%] text-[40rem] font-bold leading-none text-secondary/[0.05] select-none pointer-events-none font-default" aria-hidden="true">
        L
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-8 items-center">
          {}
          <div className="lg:col-span-6 flex flex-col items-start gap-8">
            <Badge variant="outline" className="text-secondary border-secondary/30 bg-secondary/5 py-1.5 px-4 text-sm font-semibold tracking-widest uppercase font-default">
              Premium AI Enhancement
            </Badge>

            <h1 className="text-5xl lg:text-[72px] leading-[1.05] font-serif font-light tracking-wide text-foreground">
              The Art of First Impressions.
            </h1>

            <p className="text-[20px] text-muted-foreground leading-relaxed max-w-xl font-default">
              Elevate your property's presence with AI-enhanced photography that 
              captures the soul of luxury. Increase bookings and room prices 
              with visuals that resonate.
            </p>

            <div className="flex flex-wrap items-center gap-4 pt-4">
              <Button size="lg" className="h-14 px-8 text-base rounded-md shadow-md bg-secondary text-secondary-foreground hover:opacity-90 transition-all duration-300" asChild>
                <Link to="/HomePage">
                  Elevate Your Property <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
              <Button variant="ghost" size="lg" className="h-14 px-6 text-base rounded-md gap-2 hover:bg-accent/50 text-foreground font-default">
                <Play className="size-5 fill-secondary text-secondary" /> Experience Better Hotel Photos
              </Button>
            </div>
          </div>

          {}
          <div className="lg:col-span-6 relative lg:pl-10">
            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-secondary/5 blur-[100px] rounded-lg pointer-events-none"></div>

            {}
            <div className="relative rounded-md border-[1px] border-border bg-card shadow-xl overflow-hidden aspect-[4/3] transform transition-transform duration-700 hover:-translate-y-1 hover:shadow-2xl ring-1 ring-border/20">
              {}
              <div className="absolute top-0 inset-x-0 h-6 bg-background/80 flex justify-center items-center z-20 backdrop-blur-sm border-b border-border/50">
                <div className="w-16 h-1 rounded-lg bg-secondary/30"></div>
              </div>

              {}
              <div className="relative w-full h-full pt-6 bg-muted">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684351/img/luxury_hotel_comparison_slider.png" alt="AI Enhanced Hotel Room Comparison" className="w-full h-full object-cover object-top rounded-b-md" />
                {}
                <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-secondary/5 to-transparent pointer-events-none"></div>
                
                {}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-secondary rounded-lg flex items-center justify-center shadow-lg z-30 cursor-pointer hover:scale-110 transition-transform">
                   <div className="flex gap-1">
                      <div className="w-1.5 h-1.5 border-l-2 border-t-2 border-secondary-foreground -rotate-45"></div>
                      <div className="w-1.5 h-1.5 border-r-2 border-b-2 border-secondary-foreground -rotate-45"></div>
                   </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}